import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EmployeeContactCard } from '../models/employee-contact-card.model';
import { EnvironmentService } from "@app/core/services/environment.service";

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeContactCardService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getAllEmployeeContactCards(take?: number, skip?: number, filterString?: string, sortString?: string, filterInactive: boolean = true, include: string = 'ProfilePhoto'): Observable<PagedData<EmployeeContactCard>> {
    let params = new HttpParams();
    if (filterInactive) {
      filterString = filterString ? `${filterString} AND (Status.Id = "Active")` : `Status.Id = "Active"`;
    }
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    filterString ? params = params.append('Filter', filterString) : null;
    sortString ? params = params.append('Sort', sortString) : null;
    include ? params = params.append('Include', include) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${api_routes.CONTACT_CARDS}`, {
      headers: headers,
      params: params
    });
  }

  async getAllEmployeeContactCardsAsync(sort?: string, filter?: string, filterInactive?: boolean): Promise<PagedData<EmployeeContactCard>> {
    let take = 100;
    let skip = 0;
    let allData = {
      skip: null,
      take: null,
      totalPages: null,
      total: null,
      data: []
    }

    while (allData.total === null || skip < allData.total) {
      const res = await this.getAllEmployeeContactCards(take, skip, filter, sort, filterInactive).toPromise();

      if (res && res.data && res.data.length > 0) {
        allData.data = allData.data.concat(res.data);
        skip += take;
        allData.total = res.total;
      } else {
        break;
      }
    }

    return allData;
  }

  getEmployeeContactCard(employeeId: string, include: string = 'ProfilePhoto'): Observable<EmployeeContactCard> {
    let params = new HttpParams();
    include ? params = params.append('Include', include) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${api_routes.CONTACT_CARDS}/${employeeId}`, {
      headers: headers,
      params: params
    }).pipe(
      tap(res => {
        let seen = new Set<String>();
        let managers = []
        res.managers.forEach(manager => {
          if (!seen.has(manager.id) && manager.id != employeeId) {
            seen.add(manager.id)
            managers.push(manager)
          }
        })
        res.managers = managers
        return res
      })
    );
  }
}
